<template>
  <BTabs pills v-if="settings">
    <BTab active>
      <template #title>
        <FeatherIcon icon="SettingsIcon" />
        <span>{{$t('General')}}</span>
      </template>
      <SettingsTabGeneral @refetch-data="fetchData"/>
    </BTab>

    <BTab>
      <template #title>
        <FeatherIcon icon="DollarSignIcon"/>
        <span>Facturación</span>
      </template>
      <SettingsTabFinancial />
    </BTab>

    <BTab>
      <template #title>
        <FeatherIcon icon="MailIcon"/>
        <span>Correos</span>
      </template>
      <SettingsTabEmail />
    </BTab>

    <BTab @click="showListGroup=true; showViewGroup=false; showAddGroup=false; showEditGroup=false">
      <template #title>
        <FeatherIcon icon="HomeIcon"/>
        <span>Sucursales</span>
      </template>
      <SettingsTabGroups />
    </BTab>
    
    <BTab>
      <template #title>
        <FeatherIcon icon="FileTextIcon" />
        <span>Contable</span>
      </template>
      <SettingsTabAccounting/>
    </BTab>

    <BTab>
      <template #title>
        <FeatherIcon icon="LinkIcon" />
        <span>Integraciones</span>
      </template>
      <SettingsTabPlugins />
    </BTab>

    <BTab>
      <template #title>
        <FeatherIcon icon="InfoIcon" />
        <span>{{ $t('Info') }}</span>
      </template>
      <SettingsTabInfo />
    </BTab>

  </BTabs>
</template>

<script>
import { BTabs, BTab, BCardText } from 'bootstrap-vue'
import { onUnmounted, provide, ref } from '@vue/composition-api'
import SettingsTabFinancial from './SettingsTabFinancial.vue'
import SettingsTabGroups from './SettingsTabGroups.vue'
import SettingsTabGeneral from './SettingsTabGeneral.vue'
import SettingsTabPlugins from './SettingsTabPlugins.vue'
import SettingsTabEmail from './SettingsTabEmail.vue'
import SettingsTabSyncs from './SettingsTabSyncs.vue'
import SettingsTabInfo from './SettingsTabInfo.vue'
import SettingsTabAccounting from './SettingsTabAccounting.vue'
import SettingsModule from './SettingsModule'
import store from '@/store'

export default {
  components: { BCardText, BTabs, BTab, SettingsTabGeneral, SettingsTabEmail, SettingsTabGroups, SettingsTabFinancial, SettingsTabInfo, SettingsTabPlugins, SettingsTabSyncs, SettingsTabAccounting },
  setup(){
    const SETTINGS_MODULE_NAME = 'settings'
    const settings = ref(null)
    const pits = ref(null)
    const showAddGroup = ref(false)
    const showListGroup = ref(true)
    const showEditGroup = ref(false)
    const showViewGroup = ref(false)
    const selectedGroupId = ref(null)


    provide('showAddGroup', showAddGroup)
    provide('showListGroup', showListGroup)
    provide('showEditGroup', showEditGroup)
    provide('showViewGroup', showViewGroup)
    provide('settings', settings)
    provide('pits', pits)
    provide('selectedGroupId', selectedGroupId)

    if (!store.hasModule(SETTINGS_MODULE_NAME)) store.registerModule(SETTINGS_MODULE_NAME, SettingsModule)

    onUnmounted(() => {
       if (store.hasModule(SETTINGS_MODULE_NAME)) store.unregisterModule(SETTINGS_MODULE_NAME)
    })

    const fetchData = () => {
      store.dispatch('settings/fetchSettings').then(response => { 
        settings.value = response.data.settings
        pits.value=response.data.pits
      })
    }

    fetchData()


    return {
      settings,
      showAddGroup,
      showListGroup,
      showEditGroup,
      showViewGroup,
      fetchData
    }
  }
}
</script>
